import { Button } from "@/view/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
} from "@/view/components/ui/dialog";
import { useToast } from "@/view/components/ui/use-toast";
import { useState } from "react";

interface AuthorizationModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  banks?: string[];
  onAdvance: () => void;

  onVerifyAuthorization: () => Promise<boolean>;
}

export const AuthorizationModal = ({
  isOpen,
  onOpenChange,
  title,
  banks,
  description,
  onAdvance,
  onVerifyAuthorization,
}: AuthorizationModalProps) => {
  const { toast } = useToast();
  const [isLoadingVerify, setIsLoadingVerify] = useState(false);

  const handleVerify = async () => {
    try {
      setIsLoadingVerify(true);
      const isAuthorized = await onVerifyAuthorization();
      if (!isAuthorized) {
        toast({
          title: "Erro ao verificar autorização",
          variant: "destructive",
        });
      }
      setIsLoadingVerify(false);
    } catch (error) {
      console.error(error);
      setIsLoadingVerify(false);
    }
  };
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        variant="bottomSheet"
        className="sm:max-w-lg sm:rounded-xl"
        showCloseButton={false}
      >
        <h2 className="text-center text-lg font-semibold text-black01 dark:text-white sm:text-xl">
          {title}
        </h2>
        <p className="text-center text-sm font-medium text-black01 dark:text-gray-300 sm:text-base">
          {description}
        </p>

        {banks && (
          <div className="mt-4 text-center">
            <ul className="my-2 inline-block list-inside list-disc space-y-1 text-center marker:text-black01 dark:marker:text-gray-300">
              {banks.map((bank, index) => (
                <li
                  key={index}
                  className="text-xs font-bold text-black01 dark:text-gray-300"
                >
                  {bank}
                </li>
              ))}
            </ul>
          </div>
        )}

        <DialogFooter className="flex flex-col justify-center gap-2 sm:flex sm:space-x-0">
          <Button
            isLoading={isLoadingVerify}
            variant="outline"
            onClick={handleVerify}
            size="lg"
            className="w-full rounded-full bg-gray01 hover:bg-gray01 dark:text-black01"
          >
            Já autorizei
          </Button>
          <Button
            disabled={isLoadingVerify}
            onClick={onAdvance}
            size="lg"
            className="w-full rounded-full bg-primary text-white"
          >
            Ver o passo a passo
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
